import { render, staticRenderFns } from "./input-custom.vue?vue&type=template&id=2fe0f924"
import script from "./input-custom.vue?vue&type=script&lang=js"
export * from "./input-custom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports